import { render, staticRenderFns } from "./jpkc.vue?vue&type=template&id=190ce47f&scoped=true&"
import script from "./jpkc.vue?vue&type=script&lang=js&"
export * from "./jpkc.vue?vue&type=script&lang=js&"
import style0 from "./jpkc.vue?vue&type=style&index=0&id=190ce47f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190ce47f",
  null
  
)

export default component.exports